import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import { defineComponent, inject, Ref } from "vue";
import EmailInput from "../Common/EmailInput.vue";
import SubmitButton from "../Common/SubmitButton/SubmitButton.vue";
import ForgotPassword from "./ForgotPassword.class";
import { setupComponent } from "@studyportals/vue-platform";

export default defineComponent({
	components: {
		EmailInput,
		SubmitButton,
	},
	setup: () => {
		const store = inject<IIncentiveV2Store>("incentiveV2Store");
		const isForgotPassword = inject<Ref<boolean>>("isForgotPassword");
		if (!store || !isForgotPassword) throw new Error("incentiveV2Store or isForgotPassword was not provided");
		const component = new ForgotPassword(store, isForgotPassword);
		return setupComponent(component);
	},
});
